module.exports = __webpack_public_path__ + "static/media/rate.bbadd6bf.svg";